import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";
import Navbar from "./Navbar";
import { useAuth } from "../context/AuthContext"; // Assuming you have an auth context
import * as FaIcons from "react-icons/fa";

// Explicitly type the icons
const FaHome = FaIcons.FaHome as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaUsers = FaIcons.FaUsers as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaShoppingCart = FaIcons.FaShoppingCart as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaBox = FaIcons.FaBox as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaFolderOpen = FaIcons.FaFolderOpen as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaPen = FaIcons.FaPen as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaImage = FaIcons.FaImage as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaMoneyBillWave = FaIcons.FaMoneyBillWave as unknown as React.FC<React.SVGProps<SVGSVGElement>>;


interface SidebarProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, setIsOpen }) => {
  const { currentUser } = useAuth(); // Get current user from your auth context

  // console.log("Current User:", currentUser);
  
  const handleLinkClick = () => {
    setIsOpen(false);
  };

  const handleMouseEnter = () => {
    if (window.innerWidth > 768) setIsOpen(true);
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 768) setIsOpen(false);
  };

  const handleOverlayClick = () => setIsOpen(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isOpen) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen, setIsOpen]);

  // // Define admin-only links
  // const adminLinks = [
  //    { path: "/admin/dashboard", icon: "🏠", label: "Dashboard" },
  //   { path: "/admin/Users", icon: "👥", label: "All Users" },
  //   { path: "/admin/adminproduct", icon: "🛒", label: "All Products" },
  //   { path: "/admin/OrderManage", icon: "📦", label: " All Orders" },
  //   { path: "/admin/category", icon: "🗂️", label: "Category" },
  //   { path: "/admin/CMS", icon: "📝", label: "CMS Management" },
  //   { path: "/admin/banner", icon: "🖼️", label: "Banner Management" },
  //   { path: "/admin/trans", icon: "💰", label: "Transaction Report" }, 
  //   { path: "/admin/rewards", icon: "💰", label: "Rewards Management" }, 
  // ];

  // // Define common links for all roles
  // const commonLinks = [
  //   { path: "/vendor/dashboard", icon: "🏠", label: "Dashboard" },
  //    { path: "/vendor/vendorproducts", icon: "🛒", label: "Products" },
  //   { path: "/vendor/vendoruser", icon: "👥", label: " Users" },
  //   { path: "/vendor/OrderManage", icon: "📦", label: "Orders" },
  // ];

  // ✅ Define admin-only links with React Icons
const adminLinks = [
  { path: "/admin/dashboard", icon: <FaHome />, label: "Dashboard" },
  { path: "/admin/Users", icon: <FaUsers />, label: "All Users" },
  { path: "/admin/adminproduct", icon: <FaShoppingCart />, label: "All Products" },
  { path: "/admin/OrderManage", icon: <FaBox />, label: "All Orders" },
  { path: "/admin/category", icon: <FaFolderOpen />, label: "Category" },
  { path: "/admin/CMS", icon: <FaPen />, label: "CMS Management" },
  { path: "/admin/banner", icon: <FaImage />, label: "Banner Management" },
  { path: "/admin/trans", icon: <FaMoneyBillWave />, label: "Transaction Report" },
  { path: "/admin/rewards", icon: <FaMoneyBillWave />, label: "Rewards Management" },
];

// ✅ Define common links for all roles
const commonLinks = [
  { path: "/vendor/dashboard", icon: <FaHome />, label: "Dashboard" },
  { path: "/vendor/vendorproducts", icon: <FaShoppingCart />, label: "Products" },
  { path: "/vendor/vendoruser", icon: <FaUsers />, label: "Users" },
  { path: "/vendor/OrderManage", icon: <FaBox />, label: "Orders" },
];

  // Combine links based on role
  const getLinks = () => {
    if (currentUser?.role === "admin") {
      // console.log("Admin Links:", adminLinks);
      // console.log("role: ",currentUser?.role);
      // return [...commonLinks, ...adminLinks];
      return adminLinks;
    }
    return commonLinks;
  };

  return (
    <>
      {isOpen && window.innerWidth <= 768 && (
        <div className="overlay" onClick={handleOverlayClick}></div>
      )}

      <div style={{ display: "flex" }}>
        <div
          className={`sidebar ${isOpen ? "open" : "closed"}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onTouchStart={handleMouseEnter}
        >
          <nav>
            <ul>
              {getLinks().map((link) => (
                <li key={link.path}>
                  <Link to={link.path} onClick={handleLinkClick}>
                    {link.icon} {isOpen && <span className="label">{link.label}</span>}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div>
          <Navbar isSidebarOpen={isOpen} setIsOpen={setIsOpen} />
          <div className="page-content"></div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;